import { useRef } from "react";
import { Checkbox } from "../Checkbox/Checkbox";
import "./checkForm.css";

export const CheckForm = ({ children, onClick }) => {
    const checkedRef = useRef(false);

    const toggleCheckbox = (value) => {
        checkedRef.current = value;
        onClick(checkedRef.current);
    }

    return (
        <div className="check-form">
        <Checkbox onClick={toggleCheckbox} />
        <p className="body4">{children}</p>
      </div>
    );
}